import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";

const LoadError = () => {
  const { t } = useLang();
  const [{ isRejected }] = usePayPalScriptReducer();
  return isRejected ? <p className="text-sm text-rose-600" data-testid="paypal-load-error">{t("pp_unavailable")}</p> : null;
};
import { toast } from "sonner";
import { useLang } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";
import { api, errMsg } from "../../lib/api";

export const PaymentMethods = ({ methods, eventId }) => {
  const { t } = useLang();
  const { data: cfg } = useFetch(`/paypal/config?event_id=${eventId}`);
  const list = (methods || []).filter((m) => ["Bank transfer", "Cash", "Card (POS)"].includes(m) || (m === "PayPal" && cfg?.enabled));
  if (!list.length) return null;
  return (
    <div data-testid="event-payment-methods">
      <p className="eyebrow">{t("payment_methods")}</p>
      <p className="mt-3 flex flex-wrap gap-2 text-sm font-semibold text-[#0A2540]">
        {list.map((m) => <span key={m} className="rounded-full border border-slate-300 bg-white px-3 py-1" data-testid={`event-payment-method-${m.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{m}</span>)}
      </p>
    </div>
  );
};

export const PayPalPay = ({ order, onPaid }) => {
  const { t } = useLang();
  const { data: cfg } = useFetch(`/me/orders/${order.id}/paypal-config`);
  if (!cfg?.enabled || order.paypal_allowed === false || !(order.balance ?? order.totals?.gross) || order.balance <= 0) return null;
  return (
    <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-4" data-testid={`paypal-pay-${order.id}`}>
      <p className="mb-3 text-sm font-semibold text-[#0A2540]">{t("pp_pay_title")}{cfg.mode === "sandbox" && <span className="ml-2 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase text-amber-800" data-testid="paypal-sandbox-badge">Sandbox</span>}</p>
      <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: "EUR", intent: "capture" }}>
        <LoadError />
        <PayPalButtons
          style={{ layout: "horizontal", tagline: false, height: 40 }}
          createOrder={async () => {
            try {
              return (await api.post(`/me/orders/${order.id}/paypal`)).data.paypal_order_id;
            } catch (e) {
              toast.error(errMsg(e));
              throw e;
            }
          }}
          onApprove={async (d) => {
            try {
              await api.post(`/me/orders/${order.id}/paypal/${d.orderID}/capture`);
              toast.success(t("pp_paid"));
              onPaid?.();
            } catch (e) {
              toast.error(errMsg(e));
            }
          }}
          onError={() => toast.error(t("pp_error"))}
        />
      </PayPalScriptProvider>
    </div>
  );
};
